import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import Login from './Login';
function App() {
  const [userRole, setUserRole] = useState(localStorage.getItem('user_role'));
  const [userDepartment, setUserDepartment] = useState(localStorage.getItem('user_department'));
  const [userName, setUserName] = useState(localStorage.getItem('user_name'));
  const [authToken, setAuthToken] = useState(localStorage.getItem('auth_token'));

  useEffect(() => {
    if (userRole && authToken) {
      localStorage.setItem('user_role', userRole);

      localStorage.setItem('user_department', userDepartment);
      localStorage.setItem('user_name', userName);
      localStorage.setItem('auth_token', authToken);
    } else {
      localStorage.removeItem('user_role');
      localStorage.removeItem('user_department');
      localStorage.removeItem('user_name');
      localStorage.removeItem('auth_token');
    }
  }, [userRole, authToken, userDepartment, userName]);

  function handleLogin(user) {
    setUserRole(user.role);
    setUserDepartment(user.department);
    setUserName(user.name);
    setAuthToken(localStorage.getItem('auth_token'));
  }

  function handleLogout() {
    localStorage.removeItem('user_role');
    localStorage.removeItem('user_department');
    localStorage.removeItem('user_name');
    localStorage.removeItem('auth_token');
    setUserRole(null);
    setUserDepartment(null);
    setUserName(null);
    setAuthToken(null);
  }

  if (!userRole) {
    return (
      <div className="app-wrapper">
        <Login onLogin={handleLogin} />
      </div>
    );
  }

  const allowedRoles = ['admin', 'accounts_1st', 'purchase_office', 'accounts_2nd', 'accounts_3rd', 'final_accountant'];

  if (!allowedRoles.includes(userRole)) {
    return (
      <div className="app-wrapper">
        <div className="unauthorized">
          <h2>Unauthorized Role</h2>
          <p>Your account does not have access to this application.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="app-wrapper" style={{ overflow: "hidden", height: "100vh" }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard role={userRole} department={userDepartment} userName={userName} onLogout={handleLogout} />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
       
      </BrowserRouter>
       <ToastContainer position="top-right" />
    </div>
  );
}

export default App;
